
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { CmsBannerComponent, CmsService, FeaturesConfigModule, SemanticPathService, UrlModule } from '@spartacus/core';
import { BannerComponent, CmsComponentData, GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { GenGaListNames } from 'src/app/generac/enums/ga-list-names.enum';
import { GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';

@Component({
  selector: 'gen-banner',
  templateUrl: './banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    GenericLinkModule,
    MediaModule,
    FeaturesConfigModule,
    UrlModule,
  ],
})
export class GenBannerComponent extends BannerComponent {
  private readonly WHOLE_HOME_ECOSYSTEM_CODE = 'whole-home-ecosystem';
  private readonly GA_HOMEPAGE_CREATIVE_SLOT_NAME = 'homepage_top';

  readonly ECOSYSTEM_TILE_ENTRY_SOURCE = 'ecosystem_tile';

  constructor(
    protected override component: CmsComponentData<CmsBannerComponent>,
    protected override urlService: SemanticPathService,
    protected override cmsService: CmsService,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
  ) {
    super(component, urlService, cmsService);
  }

  handleBannerClick(data: any): void {
    if (this.isEcosystemTile(data?.urlLink)) {
      this.googleAnalyticsService.sendGaEvent('entry_click', {
        entry_source: 'ecosystem_tile',
        banner_name: 'Ecosystem Tile',
      });
    } else if (this.isHomePagePromoBanner(data)) {
      this.googleAnalyticsService.sendGaEvent("select_promotion", {
        items: [{
          item_id: data.name.toLowerCase().trim().replace(/ /g, '_'),
          item_name: data.name,
          creative_slot: this.GA_HOMEPAGE_CREATIVE_SLOT_NAME,
          index: 0,
          item_list_name: GenGaListNames.HOMEPAGE_BANNER_CAROUSEL,
          item_list_id: GenGaListNames.HOMEPAGE_BANNER_CAROUSEL.toLowerCase().trim().replace(/ /g, '_'),
        }]
      });
    }
  }

  isEcosystemTile(url: string): boolean {
    return url.includes(this.WHOLE_HOME_ECOSYSTEM_CODE);
  }

  isHomePagePromoBanner(data: any) {
    return data?.rotatingComponent == 'GeneracHomepageCarouselComponent';
  }

  setRouterQueryParams(data: any): Params {
    if (this.isEcosystemTile(data?.urlLink)) {
      return { entry_source: this.ECOSYSTEM_TILE_ENTRY_SOURCE };
    } else if (this.isHomePagePromoBanner(data)) {
      return { gaListName: GenGaListNames.HOMEPAGE_BANNER_CAROUSEL }
    } else return {};
  }
}
